<mat-card>
  <h1 mat-dialog-title class="text-center">{{ data.title }}</h1>
  <mat-dialog-content>
    {{ data.content }}
  </mat-dialog-content>
  <div mat-dialog-actions class="d-flex ml-auto pb-3">
    <button type="button" mat-raised-button class="mr-2" (click)="onCancel()">
      Отмена
    </button>
    <app-button-with-progress
      typeBtn="button"
      (click)="data.onSubmit && data.onSubmit()"
      [loading$]="data.loading$ | async"
      [label]="
        data.buttonText ? data.buttonText : 'Подтвердить'
      "></app-button-with-progress>
  </div>
</mat-card>
